module.exports = __webpack_public_path__ + "img/icon-menubar-quan-active.97bdb820.png";